import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="c">
        <stop stopColor="#71ECDA" offset="0%" />
        <stop stopColor="#32B8C0" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#98F3E7" offset="0%" />
        <stop stopColor="#66D0D5" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M29 5c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 52 28.136c0 5.526-3.422 12.305-7.652 18.275C38.784 54.26 31.73 61 29 61c-2.73 0-9.784-6.74-15.348-14.59C9.422 40.442 6 33.663 6 28.137c0-6.39 2.575-12.174 6.739-16.362C16.9 7.59 22.649 5 29 5Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <path
        d="M19.018 30.429c6.809-3.342 13.322-1.43 19.964.844-.932 2.266-1.83 4.566-2.865 6.805a1.955 1.955 0 0 1-1.51.844c-3.115.068-6.23.075-9.345 0a1.99 1.99 0 0 1-1.452-.66c-1.677-2.634-3.257-5.315-4.792-7.833Zm4.554-11.903c3.103-1.43 6.013-2.817 8.993-4.083a1.62 1.62 0 0 1 1.445.68c1.593 4.424 3.135 8.895 4.792 13.74-3.603-.939-6.873-1.776-10.11-2.654a1.686 1.686 0 0 1-.7-.755c-1.414-2.225-2.846-4.45-4.42-6.928Zm-4.554 9.371 3.212-7.486 3.892 6.003-7.104 1.483Z"
        fill="#F7FFFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
